import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import ReactTable from 'react-table'
import { actions } from '../../redux/modules/employeesActions'
import { actions as userActions } from '../../redux/modules/userActions'
import 'react-table/react-table.css'
import AddEditForm from '../../components/employees/AddEditForm'
import { message, Tooltip } from 'antd'
import moment from 'moment'
import { filterCaseInsensitive } from '../../util'
import PaginationComponent from '../../components/PaginationComponent'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'

const propTypes = {}

class Employees extends Component {
  constructor(props) {
    super(props)
    this.props.employeesRefresh()
    this.props.getUserRoles()
    this.props.getUsers()

    this.state = {
      modalVisible: false,
      currentId: null,
      currentEmployee: null,
      noteAddEditContainer: false,
      currentNote: null,
      currentNoteId: null,
      followUpAddEditContainer: false,
      currentFollowUp: null,
      currentFollowUpId: null,
      followUpAssignToType: 'user'
    }
  }

  componentDidMount() {
    console.log('adasd')
  }

  handleToggleAddEditForm = () => {
    if (this.state.modalVisible) {
      this.setState({
        currentId: null,
        currentEmployee: null
      })
    }
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  handleAddEmployee = values => {
    values.hire_date = moment(values.hire_date).format('YYYY-MM-DD HH:mm:ss')
    this.props.createEmployee({
      content: values,
      userId: this.props.authentication.user.userId
    })

    this.handleToggleAddEditForm()
    message.success('Employee created')
  }

  handleEditEmployee = values => {
    values.hire_date = moment(values.hire_date).format('YYYY-MM-DD HH:mm:ss')
    values.updated_by_id = this.props.authentication.user.userId
    this.props.editEmployee({
      content: values,
      employeeId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentEmployee: null
    })

    this.handleToggleAddEditForm()
    message.success('Employee edited')
  }

  handleDeleteEmployee = () => {
    this.props.deleteEmployee({
      employeeId: this.state.currentId
    })

    this.setState({
      currentId: null,
      currentEmployee: null
    })

    this.handleToggleAddEditForm()
    message.success('Employee deleted')
  }

  handleRowClick = row => {
    this.props.getAttachments({ employeeId: row.id })
    this.props.getEmployeeNote({ employeeId: row.id })
    this.props.getEmployeeFollowUp({ employeeId: row.id })
    this.setState({
      currentId: row.id,
      currentEmployee: row
    })

    this.handleToggleAddEditForm()
  }

  setStatus = status => {
    const payload = {
      status: status ? 'active' : 'inactive',
      updated_by_id: this.props.authentication.user.userId,
      updated_date: moment().format('YYYY/MM/DD HH:mm:ss')
    }
    this.props.setStatus({
      content: payload,
      employeeId: this.state.currentId
    })
  }

  uploadAttachment = param => {
    this.props.uploadAttachment({
      formData: param.formData,
      employeeId: this.state.currentId
    })
  }

  updateAttachmentDescription = param => {
    this.props.updateAttachmentDescription(param)
  }

  deleteAttachment = param => {
    this.props.deleteAttachment(param)
  }

  // notes things
  handleToggleNoteEditArea = () => {
    this.setState({
      noteAddEditContainer: !this.state.noteAddEditContainer
    })
  }

  createNote = params => {
    this.props.createEmployeeNote({
      content: params,
      userId: this.props.authentication.userId,
      employeeId: this.state.currentId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editEmployeeNote({
      content: params,
      noteId: this.state.currentNoteId,
      employeeId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteEmployeeNote({
      noteId: this.state.currentNoteId,
      employeeId: this.state.currentId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  // follow ups things
  handleToggleFollowUpEditArea = () => {
    this.setState({
      followUpAddEditContainer: !this.state.followUpAddEditContainer
    })
  }

  createFollowUp = params => {
    params.employee_id = this.state.currentId
    this.props.createEmployeeFollowUp({
      content: params,
      employeeId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()
  }

  updateFollowUp = params => {
    this.props.editEmployeeFollowUp({
      content: params,
      followUpId: this.state.currentFollowUpId,
      employeeId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()

    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  deleteFollowUp = () => {
    this.props.deleteEmployeeFollowUp({
      followUpId: this.state.currentFollowUpId,
      employeeId: this.state.currentId
    })

    this.handleToggleFollowUpEditArea()

    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  handleRowFollowUpClick = row => {
    this.setState({
      followUpAddEditContainer: true,
      currentFollowUp: row,
      currentFollowUpId: row.id,
      followUpAssignToType: row.assigned_to_id ? 'user' : 'role'
    })
  }

  changeAssignedToType = e => {
    this.setState({
      followUpAssignToType: e.target.value
    })
  }

  handleResetFollowUpForm = () => {
    this.setState({
      currentFollowUp: null,
      currentFollowUpId: null
    })
  }

  render() {
    const {
      payload,
      employeeAttachments,
      loadingAttachments,
      uploadingAttachment,
      deletingAttachment,
      employeesNotes,
      employeesFollowUps
    } = this.props.employeesActions
    if (!payload) {
      return (
        <div>
          <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
          <span className="sr-only">Loading...</span>
        </div>
      )
    } else {
      return (
        <div>
          <AddEditForm
            currentId={this.state.currentId}
            userId={this.props.authentication.user.userId}
            modalVisible={this.state.modalVisible}
            handleToggleAddEditForm={this.handleToggleAddEditForm}
            handleAddEmployee={this.handleAddEmployee}
            handleEditEmployee={this.handleEditEmployee}
            handleDeleteEmployee={this.handleDeleteEmployee}
            currentEmployee={this.state.currentEmployee}
            setStatus={this.setStatus}
            // attachments props
            uploadAttachment={this.uploadAttachment}
            updateAttachmentDescription={this.updateAttachmentDescription}
            deleteAttachment={this.deleteAttachment}
            attachmentList={employeeAttachments && employeeAttachments.data}
            loadingAttachments={loadingAttachments}
            uploadingAttachment={uploadingAttachment}
            deletingAttachment={deletingAttachment}
            // notes props
            currentNote={this.state.currentNote}
            currentNoteId={this.state.currentNoteId}
            notes={employeesNotes && employeesNotes.data}
            handleToggleNoteEditArea={this.handleToggleNoteEditArea}
            noteAddEditContainer={this.state.noteAddEditContainer}
            createNote={this.createNote}
            handleRowNoteClick={this.handleRowNoteClick}
            updateNote={this.updateNote}
            deleteNote={this.deleteNote}
            // follow ups props
            currentFollowUp={this.state.currentFollowUp}
            currentFollowUpId={this.state.currentFollowUpId}
            followUps={employeesFollowUps && employeesFollowUps.data}
            handleToggleFollowUpEditArea={this.handleToggleFollowUpEditArea}
            followUpAddEditContainer={this.state.followUpAddEditContainer}
            createFollowUp={this.createFollowUp}
            handleRowFollowUpClick={this.handleRowFollowUpClick}
            updateFollowUp={this.updateFollowUp}
            deleteFollowUp={this.deleteFollowUp}
            autocompleteUsers={
              this.props.userActions &&
              this.props.userActions.users &&
              this.props.userActions.users.data
            }
            autocompleteRoles={
              this.props.userActions &&
              this.props.userActions.roles &&
              this.props.userActions.roles.data
            }
            followUpAssignToType={this.state.followUpAssignToType}
            changeAssignedToType={this.changeAssignedToType}
            handleResetFollowUpForm={this.handleResetFollowUpForm}
          />
          <div className="dataHeader">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/employees">Employees</Link>
                </li>
              </ol>
            </nav>
            <h2>Employees</h2>
          </div>
          <div className="dataPanel">
            <div className="wrapPanel">
              <div className="jobsBar">
                Employees
                <div className="jobsBarAdd" onClick={this.handleToggleAddEditForm}>
                  <i className="fa fa-plus-square" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">NEW EMPLOYEE</div>
                </div>
              </div>
              <ReactTable
                data={payload.data}
                getTrProps={(state, rowInfo, column, instance) => ({
                  onClick: e => this.handleRowClick(rowInfo.original)
                })}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                PaginationComponent={PaginationComponent}
                columns={[
                  {
                    columns: [
                      {
                        Header: 'First name',
                        id: 'first_name',
                        accessor: 'first_name',
                        Cell: d => {
                          const r = `${d.original.first_name ? d.original.first_name : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Last name',
                        id: 'last_name',
                        accessor: 'last_name',
                        Cell: d => {
                          const r = `${d.original.last_name ? d.original.last_name : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Phone Number',
                        id: 'phone_number',
                        accessor: 'phone_number',
                        Cell: d => {
                          if (d.original.phone_number) {
                            const r = d.original.phone_number
                            return (
                              <Tooltip
                                title={
                                  <TextMask
                                    Component={SpanAdapter}
                                    value={r}
                                    mask={[
                                      '(',
                                      /[1-9]/,
                                      /\d/,
                                      /\d/,
                                      ')',
                                      ' ',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      '-',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      ' ',
                                      'e',
                                      'x',
                                      't',
                                      ':',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/
                                    ]}
                                    guide
                                  />
                                }
                              >
                                {
                                  <TextMask
                                    Component={SpanAdapter}
                                    value={r}
                                    mask={[
                                      '(',
                                      /[1-9]/,
                                      /\d/,
                                      /\d/,
                                      ')',
                                      ' ',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      '-',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      ' ',
                                      'e',
                                      'x',
                                      't',
                                      ':',
                                      /\d/,
                                      /\d/,
                                      /\d/,
                                      /\d/
                                    ]}
                                    guide
                                  />
                                }
                              </Tooltip>
                            )
                          } else {
                            return 'N/A'
                          }
                        }
                      },
                      {
                        Header: 'E-mail',
                        id: 'email',
                        accessor: 'email',
                        Cell: d => {
                          const r = `${d.original.email ? d.original.email : 'N/A'}`
                          return <Tooltip title={r}>{r}</Tooltip>
                        }
                      },
                      {
                        Header: 'Status',
                        accessor: 'status',
                        Cell: row => {
                          let rowColor = '#FFFF00'
                          if (row.value === 'inactive') {
                            rowColor = '#ff0000'
                          } else if (row.value === 'active') {
                            rowColor = '#57d500'
                          }
                          let rowLabel = 'No Status'
                          if (row.value === 'inactive') {
                            rowLabel = 'Inactive'
                          } else if (row.value === 'active') {
                            rowLabel = 'Active'
                          }
                          return (
                            <span>
                              <span
                                style={{
                                  color: rowColor,
                                  transition: 'all .3s ease'
                                }}
                              >
                                &#x25cf;
                              </span>
                              &nbsp;{rowLabel}
                            </span>
                          )
                        },
                        filterMethod: (filter, row) => {
                          if (filter.value === 'all') return true
                          if (filter.value === 'null' && row.status == null) return true
                          return filter.value === row.status
                        },
                        Filter: ({ filter, onChange }) => (
                          <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: '100%' }}
                            value={filter ? filter.value : 'all'}
                          >
                            <option value="all">All</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                            <option value="null">No Status</option>
                          </select>
                        ),
                        minWidth: 50
                      }
                    ]
                  }
                ]}
                defaultPageSize={10}
                className="-striped -highlight"
              />
              <br />
              &copy; 2018 G-Tech Elevator Associates LLC
            </div>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = ({ employeesActions, authentication, userActions }, ownProps) => ({
  employeesActions,
  authentication,
  userActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, userActions), dispatch)
})

Employees.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Employees))



// WEBPACK FOOTER //
// ./src/containers/employees/index.js